import { useMemo } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { Logic, Operator } from 'core-components/types'
import { getAppId } from 'core/classes/helpers/getAppId'
import { CrudStoreItemCore } from 'core/classes/services/InitializationServiceCore'
import { CORE_FORM } from 'core/constants'
import { Crud } from 'core/types/Crud'
import { CrudInnerStorageFetcher } from 'core/types/CrudInnerStorageFetcher'
import { CrudStore } from 'core/types/crudStore'

/**
 *
 * @param dropdownKey
 * @param decorator Use this to add custom filters
 * @param deps Will be spread in useMemo deps
 * @param crudKey Use this if you need custom crud key in CrudStore
 * @returns
 */

interface IUseDropdownSourceParams {
  dropdownKey: string
  appId?: string
  decorator?: (crud: Crud) => Crud
}

export function useDropdownSource({
  dropdownKey,
  appId = getAppId(),
  decorator,
}: IUseDropdownSourceParams) {
  const crud = useMemo(() => {
    const crud = new Crud({
      audience: false,
      fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
        formId: CORE_FORM.dropdowns.id,
        code: CORE_FORM.dropdowns.code,
      }),
      hierarchyField: 'DropdownKey',
      hierarchyRoot: null,
      defaultPaging: {
        page: 0,
        pageSize: 3000,
      },
      defaultSort: {
        field: 'SortOrder',
        dir: 'asc',
      },
      defaultFilter: {
        logic: Logic.AND,
        filters: [
          {
            field: 'AppId',
            operator: Operator.EQUAL,
            value: appId,
          },
        ],
      },
      keyField: 'value',
    })

    crud.setRoot(dropdownKey)

    if (decorator) {
      return decorator(crud)
    } else {
      return crud
    }
  }, [appId, dropdownKey, decorator])
  return crud
}
